import React from 'react';
import { useLanguage } from '../context/LanguageContext';

const NewProcessSection = () => {
  const { language } = useLanguage();
  const sl = language === 'sl';

  const steps = sl ? [
    { num: '1', title: 'Rezervirajte brezplačen posvet', desc: '30 minut z izkušenim svetovalcem. Pregledamo vaše stanje, tveganja in možne prihranke.' },
    { num: '2', title: 'Fiksna ponudba v 48 urah', desc: 'Pisno, glede na vaš promet in obseg dokumentacije. Brez kasnejših presenečenj.' },
    { num: '3', title: 'Mi prevzamemo — vi dobite nazaj svoj čas', desc: 'Vaš skrbnik uredi prestop, oddaje in roke. Vi vodite posel.' },
  ] : [
    { num: '1', title: 'Book a free consultation', desc: '30 minutes with an experienced advisor. We review your situation, risks and potential savings.' },
    { num: '2', title: 'Fixed quote within 48 hours', desc: 'In writing, based on your turnover and document volume. No surprises later.' },
    { num: '3', title: 'We take over — you get your time back', desc: 'Your manager handles the transition, filings and deadlines. You run your business.' },
  ];

  return (
    <section id="process" className="bg-[#0E1114] text-[#F4EFE6] py-24 lg:py-[120px]" data-testid="process-section">
      <div className="max-w-[1440px] mx-auto px-6 lg:px-[120px]">
        {/* Header */}
        <div className="flex flex-col lg:flex-row justify-between lg:items-end gap-6 mb-12 lg:mb-16">
          <div>
            <span className="text-[13px] font-bold tracking-[2.5px] text-[#C9A462] block mb-5">
              {sl ? 'KAKO DELUJE' : 'HOW IT WORKS'}
            </span>
            <h2 className="font-serif text-[40px] lg:text-[64px] leading-[1.02] tracking-[-1px]">
              {sl ? (
                <>Trije koraki. <span className="italic text-[#C9A462]">Nič skrbi.</span></>
              ) : (
                <>Three steps. <span className="italic text-[#C9A462]">No worries.</span></>
              )}
            </h2>
          </div>
          <p className="text-[17px] text-[#B9B3A7] leading-[1.6] max-w-[400px]">
            {sl 
              ? 'Od prvega klica do popolne ureditve — vedno veste, kaj se zgodi, kdaj in koliko stane.'
              : 'From the first call to complete setup — you always know what happens, when and how much it costs.'}
          </p>
        </div>

        {/* Steps */}
        <div className="grid md:grid-cols-3 gap-12">
          {steps.map((step) => (
            <div key={step.num} className="border-t border-[#C9A462] pt-7 flex flex-col gap-4">
              <span className="font-serif text-[72px] lg:text-[88px] leading-[0.9] text-[#C9A462]">{step.num}</span>
              <h3 className="text-[20px] lg:text-[22px] font-bold">{step.title}</h3>
              <p className="text-[16px] text-[#B9B3A7] leading-[1.6]">{step.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default NewProcessSection;
